// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qe-0";